export const pushUnique = <T>(arr: T[], item: T, key: string) => {
  const isPresent = arr.some(el => el[key] === item[key]);
  if (!isPresent) {
    arr.push(item);
  }
}
